module.exports = __webpack_public_path__ + "static/media/ImagePlaceholder.3a5dcba8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reusable/images/ImagePlaceholder.svg
// module id = 310
// module chunks = 0